const compareValues = function(key, order = 'asc') {
    return function innerSort(a, b) {
        const varA = (typeof a[key] === 'string')
            ? a[key].toUpperCase() : a[key];
        const varB = (typeof b[key] === 'string')
            ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } 
        else if (varA < varB) {
            comparison = -1;
        }

        return ( (order === 'desc') ? (comparison * -1) : comparison );
    };
}

const sortArray = function(records, sortBy, sortDirection, pageSize, currentPage) {
        var sortedRecords = records;
        sortedRecords.sort(compareValues(sortBy, sortDirection));

        if(pageSize > 0 && sortedRecords.length > pageSize)
        {
            var start = (currentPage - 1) * pageSize;
            sortedRecords = sortedRecords.slice(start, (start + pageSize));
        }

        return sortedRecords;
    }


export const sorting = {
    compareValues,
    sortArray
    }